(function($) {

    $(".sidebar-navigation,  p, h1:not(.hero .title), h2, h3, h4, h5, h6, .text-component li, .fade-in-text").each(function () {
        //Exclude footer elements
        if( !$(this).closest('footer').length ) {
            $(this).attr("data-aos", "fade-up");
        }
    });

    $(window).load(function() {
        setTimeout(function() {
            AOS.refresh();
        }, 500);
    });

    $(window).on('load', function(){
        AOS.init({
            once: true
        });
    });

})( jQuery );